import type {CoachOrClientTaskApiModel} from '../../../api/task/types';
import type {Nullable} from '../../utility-types';

export const isTaskDone = (task?: Nullable<CoachOrClientTaskApiModel>) =>
  task?.status === 'done';
